export enum Features {
    PROGRESS_SCAN = 'progressScan',
    PORTFOLIO_DASHBOARD = 'portfolioDashboard',
    DATA_DASHBOARD = 'dataDashboard'
}
